const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,24.32,33.26,56.18H24.54L18,30.76c-.41-1.57-.75-2.14-2-2.8a34.65,34.65,0,0,0-8.14-2.71l.2-.93h14a3.84,3.84,0,0,1,3.8,3.25L29.38,46,38,24.32ZM80.75,45.78c0-8.41-11.63-8.86-11.55-12.62,0-1.15,1.11-2.37,3.49-2.67a15.46,15.46,0,0,1,8.13,1.42l1.45-6.76a22.2,22.2,0,0,0-7.71-1.41c-8.15,0-13.88,4.34-13.93,10.54-.05,4.58,4.09,7.14,7.22,8.67s4.28,2.56,4.27,4c0,2.14-2.56,3.07-4.93,3.11a17.23,17.23,0,0,1-8.47-2l-1.49,7a25.05,25.05,0,0,0,9.17,1.7c8.65,0,14.32-4.29,14.35-10.91m21.51,10.4h7.62l-6.65-31.86h-7a3.77,3.77,0,0,0-3.51,2.34L80.32,56.18H89l1.72-4.75h10.57ZM93.06,44.9l4.34-12,2.5,12ZM58.39,24.32,51.57,56.18H43.32l6.83-31.86Z",
    style: {
      fill: "#1434CB"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card_visa.8eb4d6a338d5bdab5c71e69f45d2727a.svg";
export { ForwardRef as ReactComponent };